<template>
  <div class="Melamine">
    <div class="title">Methyl Acetate</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Item" label="Item" width="150">
        </el-table-column>
        <el-table-column prop="Unit" label="Unit" width="150"> </el-table-column>
        <el-table-column prop="Index" label="Index"> </el-table-column>
        <!-- <el-table-column prop="TypicalResult" label="Typical Result">
        </el-table-column> -->
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>190kg/drum, 15.2mt/20'FCL, 25.08mt/40'FCL.</p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        A major use of methyl acetate is as a volatile low toxicity solventin
        glues, paints, and nail polish removers.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Item: "Appearance",
          Unit: "/",
          Index: "Transparent liquid, novisible impurities",
          TypicalResult: "Transparent liquid, novisible impurities",
        },
        {
          Item: "Acidity as CH3COOH",
          Unit: "wt%",
          Index: "0.01max",
          TypicalResult: "0.001",
        },
        {
          Item: "Water content",
          Unit: "wt%",
          Index: "0.050max",
          TypicalResult: "0.012",
        },
        {
          Item: "Purity",
          Unit: "wt%",
          Index: "99.7min",
          TypicalResult: "99.96",
        },
        {
          Item: "Color",
          Unit: "APHA NO",
          Index: "10max",
          TypicalResult: "1",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
